// A quoted child produces one output. Product quantity is budgeted separately.
export const NATIVE_COUNT_PARAMS = ["n", "num_images", "output_count", "max_images", "sequential_image_generation"];

export function generationCount(value: string): number | null {
  if (!/^\d+$/.test(value)) return null;
  const count = Number(value);
  return Number.isSafeInteger(count) && count > 0 ? count : null;
}

export function batchProgress(batch: { state: string; size: number; prepared_count: number; states: Record<string, number> }) {
  const completed = batch.states.completed ?? 0;
  const failed = batch.states.failed ?? 0;
  const cancelled = (batch.states.cancelled ?? 0) + (batch.state === "cancelled" ? batch.size - batch.prepared_count : 0);
  const remaining = Math.max(0, batch.size - completed - failed - cancelled);
  return { completed, failed, cancelled, remaining,
    label: remaining === 0 ? (failed ? "Finished with errors" : cancelled ? "Cancelled" : "Completed")
      : batch.state === "cancelling" ? "Cancelling unstarted outputs" : batch.state === "preparing" ? "Preparing outputs" : "In progress" };
}
